import React from "react";

import RefundDialog from "../RefundDialog";

import Modal from "../../../components/dialogs/modal";

import { RefundModalProps } from "./types";
import { useI18n } from "../../../hooks/useI18n";

const RefundModal = ({
  visible,
  onOk,
  onCancel,
  onSaveReceiptItem,
  receiptItems,
  errorMessage
}: RefundModalProps) => {
  const { t } = useI18n();
  return (
    <Modal
      title={t("common.actions.refundProducts")}
      open={visible}
      actions={[
        {
          text: "Ok",
          type: "ok",
          action: onOk
        },
        {
          text: "Cancel",
          type: "cancel",
          action: onCancel
        }
      ]}
    >
      <RefundDialog
        receiptItems={receiptItems}
        onReceiptItemChanged={onSaveReceiptItem}
      />

      {errorMessage && <div style={{ color: "#f5222d" }}>{errorMessage}</div>}
    </Modal>
  );
};

export default RefundModal;
